export default __webpack_public_path__ + "static/media/demo-1.965ee223.png";